import { Inject, Injectable } from '@angular/core';
import { BrandingV2Service } from '@galaxy/partner';
import { BrandingV2Interface } from '@vendasta/partner';
import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

interface BrandingService {
  getBranding(partnerId: string, marketId?: string): Observable<BrandingV2Interface>;
}

@Injectable()
export class LogoSource {
  readonly logoURL$: Observable<any>;

  constructor(@Inject('PARTNER_ID') partnerID$: Observable<string>, @Inject(BrandingV2Service) svc: BrandingService) {
    this.logoURL$ = partnerID$.pipe(
      switchMap((pid) => svc.getBranding(pid)),
      map((branding) => branding?.logoUrl),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
  }
}
